(() => {
  const imageAttributes = ['src', 'srcset', 'data-src', 'data-srcset'];
  const sourceSetAttributes = new Set(['srcset', 'data-srcset']);
  const roots = document.querySelectorAll('[data-goldique-ai-image-urls]');

  if (!roots.length) return;

  const cache = window.goldiqueAiImageHashCache || (window.goldiqueAiImageHashCache = new Map());
  const canonicalUrl = (value) => {
    try {
      const url = new URL(value, document.baseURI);
      if (!url.hostname) return '';
      url.searchParams.set('width', '100');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      url.hash = '';
      return url.href;
    } catch {
      return '';
    }
  };

  const imageHash = (value) => {
    const url = canonicalUrl(value);
    if (!url) return Promise.resolve('');
    if (!cache.has(url)) {
      cache.set(url, fetch(url, { mode: 'cors', credentials: 'omit' })
        .then((response) => response.ok ? response.arrayBuffer() : null)
        .then((bytes) => bytes && crypto.subtle ? crypto.subtle.digest('SHA-256', bytes) : null)
        .then((digest) => digest ? Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, '0')).join('') : '')
        .catch(() => ''));
    }
    return cache.get(url);
  };

  const imageUrls = (image) => {
    const sources = [image];
    if (image.parentElement?.tagName === 'PICTURE') {
      sources.push(...image.parentElement.querySelectorAll('source'));
    }

    const values = sources.flatMap((source) =>
      imageAttributes.flatMap((attribute) => {
        const value = source.getAttribute(attribute);
        if (!value) return [];
        if (!sourceSetAttributes.has(attribute)) return [value];

        return value
          .split(',')
          .map((candidate) => candidate.trim().split(/\s+/, 1)[0])
          .filter(Boolean);
      })
    );

    if (image.currentSrc) values.push(image.currentSrc);
    return [...new Set(values.map(canonicalUrl).filter(Boolean))];
  };

  const createImageWrapper = (image) => {
    const target = image.parentElement?.tagName === 'PICTURE' ? image.parentElement : image;
    const existingWrapper = target.parentElement;
    if (existingWrapper?.classList.contains('goldique-ai-inline-image-wrap')) return existingWrapper;

    const wrapper = document.createElement('span');
    wrapper.className = 'goldique-ai-inline-image-wrap';
    target.parentNode.insertBefore(wrapper, target);
    wrapper.appendChild(target);
    return wrapper;
  };

  const labelImage = (image) => {
      const media = image.closest('.media');
      const wrapper = media || createImageWrapper(image);
      if (wrapper.querySelector(':scope > .goldique-ai-image-badge')) return;

      const badge = document.createElement('span');
      badge.className = 'goldique-ai-image-badge goldique-ai-image-badge--inline';
      badge.textContent = 'KI-generierte Darstellung';
      wrapper.appendChild(badge);
  };

  roots.forEach((root) => {
    let selectedUrls;
    try {
      selectedUrls = JSON.parse(root.getAttribute('data-goldique-ai-image-urls')).map(canonicalUrl).filter(Boolean);
    } catch {
      return;
    }

    if (!selectedUrls.length) return;

    const selectedHashes = Promise.all(selectedUrls.map(imageHash)).then((hashes) => new Set(hashes.filter(Boolean)));
    const scan = () => {
      root.querySelectorAll('img').forEach(async (image) => {
        const candidates = imageUrls(image);
        if (!candidates.length) return;
        const hashes = await Promise.all(candidates.map(imageHash));
        if (hashes.some(Boolean)) {
          const selected = await selectedHashes;
          if (hashes.some((hash) => selected.has(hash))) labelImage(image);
        }
      });
    };

    scan();

    if (typeof MutationObserver === 'undefined') return;

    const observer = new MutationObserver(scan);

    observer.observe(root, {
      attributes: true,
      attributeFilter: imageAttributes,
      childList: true,
      subtree: true,
    });
  });
})();
